module.exports = __webpack_public_path__ + "static/media/demo.76e28e21.jpg";